import React from 'react'
import { Box, CssBaseline } from '@mui/material'

interface ILayoutProps {
  children: React.ReactNode
}

const BaseLayout: React.FC<ILayoutProps> = ({ children }) => {
  return (
    <Box sx={{
      backgroundColor: 'bw.white',
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh'
    }}>
      <CssBaseline />
      <Box sx={{ flex: 1 }}>
        {children}
      </Box>
    </Box>
  )
}

export default BaseLayout
